import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken } from "firebase/messaging";
import { doc, getDoc, getFirestore, setDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAwV2sP0NFZG3E4KrZaavGXpeWuPXT1bf0",
  authDomain: "tutify-online.firebaseapp.com",
  projectId: "tutify-online",
  storageBucket: "tutify-online.appspot.com",
  messagingSenderId: "912640961954",
  appId: "1:912640961954:web:6e892482ca5a4990aa16fb",
  measurementId: "G-7V82WQMWDG",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// eslint-disable-next-line
const analytics = getAnalytics(app);
export const messaging = getMessaging(app);
export const db = getFirestore(app);
export const auth = getAuth(app);

// =========================================================

export const generateToken = async () => {
  const permission = await Notification.requestPermission();
  console.log("permission", permission);

  if (permission === "granted") {
    const token = await getToken(messaging, {
      vapidKey:
        "BMv_houx20lYpKJVmn3NbT1f5skq_hny47kwi1sWWNarOrYt7Klc3eeE3NzSLPhAG39R14woXo32B8NZKFxoz6I",
    });
    console.log("token", token);
    if (!token) return;

    const userRef = doc(db, "users", "12");
    const userSnap = await getDoc(userRef);

    const existingToken = userSnap.exists() ? userSnap.data()?.fcmToken : null;

    // Save token only if different
    if (token !== existingToken) {
      await setDoc(userRef, { fcmToken: token }, { merge: true });
      console.log("FCM token saved/updated.");
    } else {
      console.log("FCM token already exists and is up to date.");
    }
  }
};
